import { render, staticRenderFns } from "./MentionsDialog.vue?vue&type=template&id=775b3e94&scoped=true"
import script from "./MentionsDialog.vue?vue&type=script&lang=js"
export * from "./MentionsDialog.vue?vue&type=script&lang=js"
import style0 from "./MentionsDialog.vue?vue&type=style&index=0&id=775b3e94&prod&lang=sass"
import style1 from "./MentionsDialog.vue?vue&type=style&index=1&id=775b3e94&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775b3e94",
  null
  
)

export default component.exports